import { FeatureFlagCodes, UserNotificationModel } from '@core/models';

export const USER_NOTIFICATIONS: UserNotificationModel[] = [
  {
    icon: 'ph ph-credit-card',
    title: 'CARGO RECURRENTE',
    content: `<p class="ql-align-justify">
      Conforme a la fecha límite de pago de sus avisos, se le realizará el cargo
      recurrente de la siguiente forma:
    </p>
    <br />
    <div><p>4 días antes</p></div>
    <div>Se le enviará la notificación del cargo recurrente para que pueda tener disponibles fondos y/o desbloqueada su tarjeta para el cobro automático que se realizará al día siguiente.</div>

    <div><b>3 días antes</b></div>
    <div>Se realizará el 1er intento de cargo automático. Si el cargo es exitoso se enviará su comprobante de pago, si falla se le informará que no se pudo realizar el cargo y que se hará un 2do intento en 24 horas.</div>

    <div><b>2 días antes</b></div>
    <div>Sucede el 2ndo intento de cargo automático. Si el cargo es exitoso se enviará su comprobante de pago, si falla se le informará que no se puedo realizar el cargo y que debe realizar su pago con los otros medios disponibles (SPEI, pago en línea y pago en caja del colegio).</div>

    <p><br /></p>`,
  },
  {
    icon: 'ph ph-storefront',
    title: 'REFERENCIAS PARA PAGO EN TIENDAS DE CONVENIENCIA',
    content: `<ul style="padding-left: 16px">
                <li class="ql-align-justify">
                  &nbsp;Solo se permite la generación de referencias hasta 72 horas antes de
                  la fecha de vencimiento de su aviso vigente.&nbsp;
                </li>
                <li class="ql-align-justify">
                  La referencia tiene una vigencia de 24 horas, una vez que su referencia
                  venza, podrá elegir otro método de pago.
                </li>
                <li class="ql-align-justify">
                  No debe pagar con referencias vencidas, ya que su pago no podrá ser
                  conciliado inmediatamente, ya que se tiene que generar un proceso de
                  conciliación manual y puede demorar algunos días.
                </li>
                <li class="ql-align-justify">
                  No debe pagar con referencias anteriores, ya que su pago no podrá ser
                  conciliado inmediatamente, ya que se tiene que generar un proceso de
                  conciliación manual y puede demorar algunos días.
                </li>
                <li class="ql-align-justify">
                  Si el monto excede de 20,000 MXN no se podrá generar la referencia por temas
                  de prevención de lavado de dinero.
                </li>
              </ul>
              <p><br /></p>`,
  },
  {
    icon: 'ph ph-arrow-circle-right',
    title: 'REFERENCIAS PARA SPEI',
    content: `<ul style="padding-left: 16px">
                <li class="ql-align-justify">
                  Solo se permite la generación de referencias hasta 72 horas antes de la
                  fecha de vencimiento de su aviso vigente.&nbsp;
                </li>
                <li class="ql-align-justify">
                  La referencia tiene una vigencia de 24 horas, una vez que su referencia
                  venza, podrá elegir otro método de pago.
                </li>
                <li class="ql-align-justify">
                  No debe pagar con referencias vencidas, ya que su pago no podrá ser
                  conciliado inmediatamente, ya que se tiene que generar un proceso de
                  conciliación manual y puede demorar algunos días.
                </li>
                <li class="ql-align-justify">
                  No debe pagar con referencias anteriores, ya que su pago no podrá ser
                  conciliado inmediatamente, ya que se tiene que generar un proceso de
                  conciliación manual y puede demorar algunos días.
                </li>
              </ul>
              <p><br /></p>`,
  },
  {
    icon: 'ph ph-coins',
    featureFlag: FeatureFlagCodes.CIE,
    title: 'PAGOS REFERENCIADOS (CIE)',
    content: `<ul style="padding-left: 16px">
                <li class="ql-align-justify">
                  Solo se permite la generación de referencias hasta 72 horas antes de la
                  fecha de vencimiento de su aviso vigente.&nbsp;
                </li>
                 <li class="ql-align-justify">
                 El monto máximo permitido para realizar pagos es de 20,000 pesos MXN.
                </li>
                <li class="ql-align-justify">
                  La referencia tiene vigencia únicamente durante el día en que se genera, independientemente de la hora. Una vez vencida, podrá seleccionar otro método de pago..
                </li>
                <li class="ql-align-justify">
                  No debe pagar con referencias vencidas, ya que su pago no podrá ser
                  conciliado inmediatamente, ya que se tiene que generar un proceso de
                  conciliación manual y puede demorar algunos días.
                </li>
                <li class="ql-align-justify">
                  No debe pagar con referencias anteriores, ya que su pago no podrá ser
                  conciliado inmediatamente, ya que se tiene que generar un proceso de
                  conciliación manual y puede demorar algunos días.
                </li>
              </ul>
              <p><br /></p>`,
  },
];
